export default __webpack_public_path__ + "static/media/backgroundPhoto.9a2dc644.jpg";